var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "do-rollback"
  }, [_c('div', {
    staticClass: "do-rollback__service"
  }, [_c('span', [_vm._v(" Service: ")]), _c('el-select', {
    staticClass: "do-rollback__service-options",
    attrs: {
      "placeholder": "Select service",
      "disabled": _vm.loading.repoActivities
    },
    model: {
      value: _vm.selectedService,
      callback: function ($$v) {
        _vm.selectedService = $$v;
      },
      expression: "selectedService"
    }
  }, _vm._l(_vm.serviceOptions, function (service) {
    return _c('el-option', {
      key: service.name,
      attrs: {
        "label": service.name,
        "value": service.name
      }
    });
  }), 1)], 1), _c('el-dialog', {
    attrs: {
      "title": "Are you sure you want to rollback to this commit?",
      "visible": _vm.showConfirmDialog,
      "before-close": _vm.closeRollbackDialog,
      "append-to-body": true
    },
    on: {
      "update:visible": function ($event) {
        _vm.showConfirmDialog = $event;
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.rollback
    }
  }, [_vm._v("Rollback")]), _c('el-button', {
    on: {
      "click": _vm.closeRollbackDialog
    }
  }, [_vm._v("Cancel")])], 1), _c('Table', {
    attrs: {
      "items": _vm.repoActivities,
      "columns": _vm.tableColumns,
      "actions": _vm.tableActions,
      "loading": _vm.loading.repoActivities
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }